import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.noHighlight)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.text), 1)
      ]))
    : (_ctx.isSimpleMatch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            style: _normalizeStyle({ background: _ctx.highlightColor, padding: '5px' })
          }, _toDisplayString(_ctx.text), 5)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.rangeMatchPrefix), 1),
          _createElementVNode("span", {
            style: _normalizeStyle({ background: _ctx.highlightColor, padding: '5px 0 5px 0' })
          }, _toDisplayString(_ctx.rangeMatchContent), 5),
          _createElementVNode("span", null, _toDisplayString(_ctx.rangeMatchSuffix), 1)
        ]))
}